import NiceModal from "@ebay/nice-modal-react";
import { memo } from "react";

import { File } from "types/types";
import { downloadFile, isImageUrl } from "utils/utils";
import ImagePreviewModal from "./modals/ImagePreviewModal";

const FileUrl = ({ file, files }: { file: File; files: File[] }) => {
  const onPreview = (file: File) => {
    NiceModal.show(ImagePreviewModal, { file, files });
  };

  if (isImageUrl(file.upldfilename)) {
    return (
      <button
        type="button"
        key={file.fileno}
        onClick={() => onPreview(file)}
        className="text-primary font-medium line-clamp-1 break-all"
      >
        {file.upldfilename}
      </button>
    );
  }
  return (
    <a
      onClick={(e) => downloadFile(e, file)}
      href="#"
      className="text-primary font-medium line-clamp-1 break-all"
    >
      {file.upldfilename}
    </a>
  );
};

export default memo(FileUrl);
